<template>
  <div class="number-input">
    <div class="input-wrapper">
      <label v-if="inputLabel" class="input-label">{{inputLabel}}</label>
      <input
          :autocomplete="autocomplete"
          :id="id"
          :name="id"
          :type="type"
          v-model="value"
          @change="validateValue">
    </div>
    <div v-if="inputError" class="error-message">{{inputError}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      autocomplete: String,
      fieldToUpdate: String,
      id: String,
      inputLabel: String,
      requiredLength: Number,
      type: {
        default: 'number',
        type: String
      },
    },

    name: 'NumberInput',

    data() {
      return {
        inputError: null,
        value: null,
      }
    },

    methods: {
      validateValue() {
        this.value = this.value.trim()
        const isValidLength = this.requiredLength ? this.value?.length === this.requiredLength : true,
            error_message = `must be ${this.requiredLength} digits`,
            data = isValidLength ? this.value : null

        this.inputError = isValidLength ? null : error_message
        this.$emit('updateNumber', this.fieldToUpdate, data)
      },
    }
  }
</script>

<style lang="sass">
.number-input

  .input-wrapper
    display: inline-flex
    flex-direction: column
    align-items: flex-start
    margin-top: .5rem

  .input-label
    font-size: .9rem
    margin: 0 0 .25rem 0

  input
    display: block
    margin-bottom: .25rem

</style>
